import BaseFilter from "./BaseFilter";
import Filter from "./Filter";

export default class PaginationFilter extends BaseFilter {
    constructor() {
        super();
    }

    initPagination(postType) {
        this.paginationItems = document.querySelectorAll(".js-pagination-item");
        if (this.paginationItems !== null) {
            this.paginationItems.forEach((item) => {
                item.addEventListener("click", (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    if (this.isFilterInProgress()) {
                        return;
                    }
                    this.disableFilter();
                    this.handlePaginationItem(event, postType);
                });
            });
        }
    }

    handlePaginationItem(event, postType) {
        this.page = event.target.getAttribute("data-val");

        if (!event.target.hasAttribute("data-val")) {
            this.page = event.target
                .closest(".js-pagination-item")
                .getAttribute("data-val");
        }

        let filter = new Filter();
        filter.init(postType, this.page);
    }
}
